<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none">
    <defs>
      <path
        id="a"
        d="M14.667 0A7.333 7.333 0 0 1 22 7.333v7.334A7.333 7.333 0 0 1 14.667 22H7.333A7.333 7.333 0 0 1 0 14.667V7.333A7.333 7.333 0 0 1 7.333 0h7.334zM7.333 3.667a3.666 3.666 0 0 0-3.666 3.666v7.334a3.666 3.666 0 0 0 3.666 3.666h7.334a3.666 3.666 0 0 0 3.666-3.666V7.333a3.666 3.666 0 0 0-3.666-3.666H7.333z" />
      <filter
        id="b"
        x="-24.766"
        y="-.321"
        width="45.684"
        height="45.684"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="3.667" result="effect1_foregroundBlur_70_12124" />
      </filter>
      <filter
        id="c"
        x="-.932"
        y="-3.435"
        width="45.684"
        height="45.684"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="3.667" result="effect1_foregroundBlur_70_12124" />
      </filter>
      <filter
        id="d"
        x="-10.202"
        y="-47.48"
        width="64.608"
        height="64.609"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="3.667" result="effect1_foregroundBlur_70_12124" />
      </filter>
      <filter
        id="e"
        x="-.997"
        y="-.388"
        width="46.302"
        height="46.302"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="3.667" result="effect1_foregroundBlur_70_12124" />
      </filter>
      <filter
        id="f"
        x="-2.427"
        y="-15.424"
        width="29.221"
        height="23.492"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="3.667" result="effect1_foregroundBlur_70_12124" />
      </filter>
      <linearGradient id="g" x1="11" y1="7.945" x2="11" y2="15.889" gradientUnits="userSpaceOnUse">
        <stop stop-color="#0D6BDE" />
        <stop offset="1" stop-color="#F30FB8" />
      </linearGradient>
    </defs>
    <use href="#a" fill="#0D6BDE" />
    <mask
      id="h"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="22"
      height="22">
      <use href="#a" fill="#0D6BDE" />
    </mask>
    <g mask="url(#h)">
      <path
        filter="url(#b)"
        style="mix-blend-mode: hard-light"
        d="m-15.8 7.059 22.423 6.054c.42.113.748.441.861.861l6.054 22.423a1.292 1.292 0 0 1-1.586 1.586l-22.423-6.054a1.222 1.222 0 0 1-.861-.861l-6.054-22.423A1.292 1.292 0 0 1-15.8 7.059z"
        fill="#FF0C68" />
      <path
        filter="url(#c)"
        style="mix-blend-mode: hard-light"
        d="m35.786 34.87-22.423-6.055a1.222 1.222 0 0 1-.861-.861L6.447 5.53a1.292 1.292 0 0 1 1.587-1.586l22.422 6.054c.42.113.748.441.862.861l6.054 22.423c.26.966-.62 1.847-1.586 1.586z"
        fill="#FF0C68" />
      <path
        filter="url(#d)"
        style="mix-blend-mode: plus-lighter"
        d="m-.24-40.072 36.517 9.86c.42.113.748.44.862.86l9.86 36.518c.419 1.555-1 2.974-2.555 2.554L7.927-.14A1.222 1.222 0 0 1 7.065-1l-9.86-36.518c-.42-1.555 1-2.974 2.555-2.554z"
        fill="#26C532" />
      <path
        filter="url(#e)"
        d="m8.002 6.992 22.883 6.179c.42.113.748.441.861.861l6.179 22.883a1.318 1.318 0 0 1-1.618 1.618l-22.883-6.178a1.222 1.222 0 0 1-.862-.862L6.384 8.61a1.318 1.318 0 0 1 1.618-1.618z"
        fill="#0D6BDE" />
      <path
        filter="url(#f)"
        d="M18.957.735 10.354.707A1.222 1.222 0 0 1 9.302.099L4.976-7.337a.5.5 0 0 1 .435-.753l8.603.028c.434.001.834.233 1.052.607l4.326 7.437a.5.5 0 0 1-.435.753z"
        fill="#26C532" />
    </g>
    <path
      d="M11.638 13.488a2.486 2.486 0 0 1 1.85-1.85c.308-.072.568-.321.568-.638 0-.316-.26-.566-.568-.638a2.486 2.486 0 0 1-1.85-1.85c-.072-.307-.322-.567-.638-.567s-.566.26-.638.568a2.486 2.486 0 0 1-1.85 1.849c-.307.072-.567.322-.567.638 0 .317.26.566.568.638a2.486 2.486 0 0 1 1.849 1.85c.072.308.322.568.638.568s.566-.26.638-.568z"
      fill="url(#g)" />
  </svg>
</template>
<script setup lang="ts">
defineOptions({
  name: 'mark-product-ai-suite'
})
</script>
